export const NavList = {
    // Public Routes
    HOMEPAGE: "/",
    PRIVACY_POLICIES: "/privacy-policy",
    TERMS_OF_USE: "/terms-of-use",

    // Private Routes
    NOT_FOUND: "/*",

    //Market Place
    MARKET_PLACE: "/marketplace",

    //Cart
    CART: "/cart",

    //Api Details
    API_DETAILS: "/api/",

    //Order Details
    ORDER_DETAILS: "/order/",
    ORDERS: "/orders",

    // API Listing
    API_LISTING_PRODUCTION: "/api-listing/production",
    API_LISTING_LIVE: "/api-listing/live",
    LIVE_API_DETAILS: "/live/",

    // Production Flow
    PRODUCTION_LEGAL: "/production/legal-and-formalities",
    PRODUCTION_COMMERCIALS: "/production/commercials",
    PRODUCTION_CHECKOUT: "/production/checkout",

    // Support
    SUPPORT_REQUESTS: "/support/requests",
    SUPPORT_TICKET_VIEW: "/support/requests/",

    // User Profile & Wishlist
    USER_PROFILE: "/user/profile",
    WISHLIST: "/wishlist",
};
